/**
 * Conditional writes to a work order operation's customFields. Each writer owns a
 * version counter next to its keys, bumped on every write; a write only lands if
 * the counter is still the value the writer read (APPEND_WOO_CUSTOM_FIELDS_IF_VERSION),
 * otherwise the writer re-reads and reapplies. updatedAt can't serve: it is not
 * bumped on customFields writes.
 */

// Picks (plConsumptions). The connector must honour it too.
export const PL_CONSUMPTIONS_VERSION_KEY = 'plConsumptionsVersion';

export const readVersion = (value) => {
  return Number.isFinite(value) ? value : null;
};

export const nextVersion = (version) => {
  return (version ?? 0) + 1;
};

// "This WOO, still at the version read." Never-versioned matches only while it
// still has no version.
export const versionWhere = (workOrderOperationRef, versionKey, version) => {
  return {
    _and: [
      { workOrderOperationRef: { _eq: workOrderOperationRef } },
      version == null
        ? { _not: { customFields: { _has_key: versionKey } } }
        : { customFields: { _contains: { [versionKey]: version } } },
    ],
  };
};
